import { BehaviorSubject, MonoTypeOperatorFunction, Observable, defer, finalize } from "rxjs";

export function setLoader<T>(
  loaderSubject: BehaviorSubject<Record<string, boolean>>,
  key: string
): MonoTypeOperatorFunction<T> {
  return (source: Observable<T>) =>
    defer(() => {
      loaderSubject.next({
        ...loaderSubject.value,
        [key]: true,
      });

      return source.pipe(
        finalize(() => {
          loaderSubject.next({
            ...loaderSubject.value,
            [key]: false,
          });
        })
      );
    });
}
